import PropTypes from 'prop-types'
import React from 'react'

import { Color } from 'constants/color.js'

import { textLevels } from './helpers/size'
import { StyledText } from './styles'

const Text = props => {
    return <StyledText {...props}>{props.children}</StyledText>
}

Text.propTypes = {
    bold: PropTypes.bool,
    color: PropTypes.string,
    level: PropTypes.oneOf(Object.values(textLevels)),
    css: PropTypes.oneOfType([PropTypes.string, PropTypes.array]), // style overrides
}

Text.defaultProps = {
    bold: true,
    color: Color.white,
    level: textLevels[1],
    css: '',
}

export default Text
